import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch } from "./apiClient";

async function readJsonResponse(response, readFailedMessage) {
  try {
    return await response.json();
  } catch {
    throw new Error(readFailedMessage);
  }
}

export async function fetchUserManagementUsers({ search = "" } = {}) {
  const params = new URLSearchParams();
  const trimmedSearch = String(search || "").trim();

  if (trimmedSearch) {
    params.set("search", trimmedSearch);
  }

  const queryString = params.toString();
  const response = await apiFetch(
    queryString
      ? `${API_ENDPOINTS.userManagement.users}?${queryString}`
      : API_ENDPOINTS.userManagement.users,
    {
      cache: "no-store",
    },
  );
  const result = await readJsonResponse(
    response,
    API_ERROR_MESSAGES.userManagementUsersReadFailed,
  );

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.userManagementUsersFetchFailed,
    );
  }

  return result;
}

export async function fetchUserManagementOptions() {
  const response = await apiFetch(API_ENDPOINTS.userManagement.options, {
    cache: "no-store",
  });
  const result = await readJsonResponse(
    response,
    API_ERROR_MESSAGES.userManagementOptionsReadFailed,
  );

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.userManagementOptionsFetchFailed,
    );
  }

  return result;
}

export async function fetchUserAssignmentRules(userId) {
  const response = await apiFetch(API_ENDPOINTS.userManagement.rules(userId), {
    cache: "no-store",
  });
  const result = await readJsonResponse(
    response,
    API_ERROR_MESSAGES.userManagementRulesReadFailed,
  );

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.userManagementRulesFetchFailed,
    );
  }

  return result.rules || [];
}

export async function updateUserManagementUser(userId, payload) {
  const response = await apiFetch(API_ENDPOINTS.userManagement.user(userId), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const result = await readJsonResponse(
    response,
    API_ERROR_MESSAGES.userManagementUpdateReadFailed,
  );

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.userManagementUpdateFailed,
    );
  }

  return result;
}
